import { render, staticRenderFns } from "./AlipayTransfer.vue?vue&type=template&id=e05d2788&scoped=true"
import script from "./AlipayTransfer.vue?vue&type=script&lang=js"
export * from "./AlipayTransfer.vue?vue&type=script&lang=js"
import style0 from "./AlipayTransfer.vue?vue&type=style&index=0&id=e05d2788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05d2788",
  null
  
)

export default component.exports